/*
    HERE IS AN EXAMPLE OF COMPOSITION API SETUP VERSION OF A STORE:
    IN THIS APPROACH, CAN'T BE USING THESE ALL CAPS CONSTS TO BUILD THINGS
    SO I DID ALL STORES IN OPTIONS WAY, WHICH ENABLE THIS APPROACH USING []
*/

// export const useNavViewType = defineStore('navViewType', () => {
//   const viewType = ref(null);

//   const getIsDesktopView = computed(() => viewType.value === viewTypes.desktop);
//   const getIsMobileView = computed(() => viewType.value === viewTypes.mobile);

//   function setHeaderType(type) {
//     viewType.value = type;
//   }

//   return {
//     viewType,
//     getIsDesktopView,
//     getIsMobileView,
//     setHeaderType,
//   };
// });
import { defineStore } from 'pinia';
import { viewTypes } from '#shared/constants';
import { SET_VIEW_TYPE } from '#shared/types/actions';
import { GET_IS_MOBILE_VIEW, GET_IS_DESKTOP_VIEW } from '#shared/types/getters';

export const useNavViewType = defineStore('navViewType', {
  state: () => ({
    viewType: null,
  }),
  getters: {
    [GET_IS_DESKTOP_VIEW]: (state) => state.viewType === viewTypes.desktop,
    [GET_IS_MOBILE_VIEW]: (state) => state.viewType === viewTypes.mobile,
  },
  actions: {
    [SET_VIEW_TYPE](type) {
      this.viewType = type;
    },
  },
});
